import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { Weekdays } from 'utils/constants'
import { CustomScheduleVisit, VisitsByWeekday } from './types'
import { SharedCareQuestionnaireItem } from '../../hooks/constants'
import { getAnswerValuesFromItems } from '../../helpers'
import { ServicePlanAssessmentQuestionnaireItem } from '../../ServicePlanAssessment/types/questionnaire'

export const extractCustomScheduleVisits = (
  flatAnswers: Record<string, QuestionnaireResponseItem>
): CustomScheduleVisit[] => {
  const visitsAnswers =
    flatAnswers[SharedCareQuestionnaireItem('VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS')]?.answer
  if (!visitsAnswers) return []

  return visitsAnswers.map((visitAnswer, index) => {
    const item = visitAnswer.item ?? []

    const visitPeriodItems =
      item.find(
        (item) =>
          item.linkId ===
          SharedCareQuestionnaireItem('VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD')
      )?.item ?? []

    const [[start], [end], [caregiverReferenceOrId], [weekday], [serviceType]] = [
      SharedCareQuestionnaireItem('VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_START'),
      SharedCareQuestionnaireItem('VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_END'),
      SharedCareQuestionnaireItem('VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_CAREGIVER'),
      SharedCareQuestionnaireItem('VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_WEEKDAY'),
      ServicePlanAssessmentQuestionnaireItem.VISIT_SCHEDULING_CUSTOM_SCHEDULE_VISITS_PERIOD_SERVICE_TYPE
    ].map((linkId) => getAnswerValuesFromItems(visitPeriodItems, linkId))

    // TODO (Jason / ENG-3782): necessary to shim existing ID values to reference
    let caregiverReference: string | null = null
    if (caregiverReferenceOrId) {
      caregiverReference = caregiverReferenceOrId.includes('/')
        ? caregiverReferenceOrId
        : `Practitioner/${caregiverReferenceOrId}`
    }

    return {
      caregiverReference,
      weekday: weekday ?? null,
      period: [start, end],
      serviceType: serviceType?.reference ?? null,
      visitNumber: index + 1
    }
  })
}

export const groupVisitsByWeekday = (
  visits: CustomScheduleVisit[]
): Record<Weekdays, CustomScheduleVisit[]> => {
  const visitsByWeekday = visits.reduce(
    (weeklySchedule, visit) => {
      if (!visit.weekday) {
        Object.entries(weeklySchedule).forEach(([weekday, visitsForWeekday]) =>
          visitsForWeekday.push({ ...visit, weekday })
        )
      } else {
        weeklySchedule[visit.weekday].push({ ...visit })
      }

      return weeklySchedule
    },
    {
      [Weekdays.MONDAY]: [],
      [Weekdays.TUESDAY]: [],
      [Weekdays.WEDNESDAY]: [],
      [Weekdays.THURSDAY]: [],
      [Weekdays.FRIDAY]: [],
      [Weekdays.SATURDAY]: [],
      [Weekdays.SUNDAY]: []
    } as VisitsByWeekday
  )

  return visitsByWeekday
}
